import { gql } from '@apollo/client';

export const partnerQuery = gql`
  query PartnerQuery ($id: ID!) {
    partner (id: $id) {
      id
      name
      company {
        id
        theme {
          icon
        }
      }
    }
  }
`;